import React from 'react';
import { Grid } from '@material-ui/core';
import { styled } from '../components/styled';

const Page = styled('main')({
  minHeight: '100vh',
  padding: '32px 20px 56px',
  background:
    'radial-gradient(circle at top left, rgba(31, 122, 90, 0.12), transparent 34%), radial-gradient(circle at top right, rgba(18, 84, 62, 0.1), transparent 30%), linear-gradient(180deg, #fffefb 0%, #f4f1ea 55%, #f7f2e8 100%)',
});

const Container = styled('div')({
  maxWidth: 1100,
  margin: '0 auto',
});

const Hero = styled('header')({
  position: 'relative',
  overflow: 'hidden',
  border: '1px solid rgba(31, 122, 90, 0.16)',
  borderRadius: 28,
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(244, 249, 246, 0.92))',
  boxShadow: '0 20px 60px rgba(30, 40, 50, 0.12)',
  padding: '34px 28px',
});

const Badge = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  padding: '8px 14px',
  borderRadius: 999,
  background: 'rgba(31, 122, 90, 0.08)',
  color: '#14553e',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
});

const Title = styled('h1')({
  margin: '18px 0 10px',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 'clamp(2.3rem, 4vw, 4rem)',
  lineHeight: 1.02,
  letterSpacing: '-0.03em',
});

const Intro = styled('p')({
  maxWidth: 780,
  margin: 0,
  color: '#5f6b76',
  fontSize: 18,
});

const MetaGrid = styled(Grid)({
  marginTop: 24,
});

const MetaCard = styled('div')({
  padding: '16px 18px',
  border: '1px solid rgba(31, 122, 90, 0.12)',
  borderRadius: 14,
  background: 'rgba(255, 255, 255, 0.86)',
});

const MetaLabel = styled('span')({
  display: 'block',
  marginBottom: 6,
  color: '#5f6b76',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
});

const MetaValue = styled('span')({
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 16,
  fontWeight: 700,
  color: '#1f2933',
});

const Content = styled('div')({
  display: 'grid',
  gap: 18,
  marginTop: 22,
});

const Section = styled('section')({
  border: '1px solid rgba(31, 122, 90, 0.16)',
  borderRadius: 20,
  background: 'rgba(255, 255, 255, 0.88)',
  boxShadow: '0 20px 60px rgba(30, 40, 50, 0.12)',
  padding: '26px 26px 22px',
  backdropFilter: 'blur(8px)',
});

const SectionTitle = styled('h2')({
  margin: '0 0 14px',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 'clamp(1.2rem, 2vw, 1.7rem)',
  lineHeight: 1.15,
  letterSpacing: '-0.02em',
});

const Text = styled('p')({
  margin: '0 0 12px',
  color: '#1f2933',
  lineHeight: 1.7,
});

const List = styled('ul')({
  margin: 0,
  paddingLeft: 20,
});

const OrderedList = styled('ol')({
  margin: 0,
  paddingLeft: 20,
});

const Note = styled('div')({
  borderLeft: '4px solid #1f7a5a',
  padding: '18px 18px 18px 20px',
  borderRadius: 16,
  background: 'linear-gradient(180deg, rgba(31, 122, 90, 0.08), rgba(31, 122, 90, 0.03))',
});

const Footer = styled('p')({
  marginTop: 18,
  padding: '18px 6px 0',
  color: '#5f6b76',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 15,
  lineHeight: 1.6,
});

const PrivacyPolicy = () => (
  <Page>
    <Container>
      <Hero>
        <Badge>AsoBike • Privacy Policy</Badge>
        <Title>Privacy policy</Title>
        <Intro>
          Gentile Utente, abbiamo a cuore la sicurezza dei suoi dati personali e le garantiamo la massima riservatezza nel loro trattamento, nel rispetto dei principi di correttezza, liceità e trasparenza, in conformità al Regolamento UE 2016/679 (“General Data Protection Regulation” – GDPR) e della normativa applicabile in materia di privacy.
        </Intro>

        <MetaGrid container spacing={2} aria-label="Informazioni principali">
          <Grid item xs={12} md={4}>
            <MetaCard>
              <MetaLabel>Titolare</MetaLabel>
              <MetaValue>EugeniUp S.r.l.</MetaValue>
            </MetaCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <MetaCard>
              <MetaLabel>Contatto</MetaLabel>
              <MetaValue>eugeniupsrl@pec.it</MetaValue>
            </MetaCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <MetaCard>
              <MetaLabel>Ultimo aggiornamento</MetaLabel>
              <MetaValue>3.3.2025</MetaValue>
            </MetaCard>
          </Grid>
        </MetaGrid>
      </Hero>

      <Content>
        <Section>
          <SectionTitle>Titolare del trattamento e rapporto con i fornitori del servizio</SectionTitle>
          <Text>
            Titolare del Trattamento dei dati, per le finalità specificate nella presente privacy policy, è EugeniUp S.r.l. (d’ora in avanti EugeniUp), con sede legale in Ortezzano (FM), Piazza Umberto I 1/B, P.IVA n. 02427640442, Tel. 3398141388, e-mail: eugeniupsrl@gmail.com, PEC: eugeniupsrl@pec.it.
          </Text>
          <Text>
            Asobike è un marchio registrato da EugeniUp S.r.l. e contraddistingue una rete di fornitori di servizi di noleggio di biciclette, che operano come soggetti tra loro indipendenti, fornendo i propri servizi per mezzo della Piattaforma. La Piattaforma consente agli Utenti di individuare e accedere ai servizi offerti da ciascun fornitore, restando ciascun contratto relativo alla fornitura di tali servizi concluso esclusivamente tra l’Utente e il fornitore responsabile del singolo noleggio.
          </Text>
          <Text>
            La richiesta dei servizi ad uno dei fornitori tramite la Piattaforma può essere eseguita esclusivamente da Utenti registrati e comporta il trasferimento ai fornitori dei dati personali dell’Utente necessari alla corretta conclusione ed esecuzione del contratto. I dati personali trasmessi saranno trattati dal singolo fornitore in conformità alla propria Privacy Policy.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Categorie di dati trattati</SectionTitle>
          <Text>I dati trattati da EugeniUp, previo loro conferimento da parte dell’Utente, mediante la Piattaforma, sono:</Text>
          <List>
            <li>dati anagrafici dell’Utente (nome e cognome, data di nascita, codice fiscale, Partita IVA);</li>
            <li>indirizzi e recapiti (indirizzo di residenza/domicilio, telefono fisso e/o mobile, fax, e-mail);</li>
            <li>dati di pagamento (es. carta di credito);</li>
            <li>dati relativi ai servizi forniti (es. storico acquisti).</li>
          </List>
          <Text>
            Il conferimento dei predetti dati è obbligatorio per poter fruire dei servizi forniti mediante la Piattaforma. Il rifiuto del conferimento dei dati potrebbe comportare l’impossibilità di fornire, in tutto o in parte, i servizi richiesti e/o di concludere i contratti di noleggio con i fornitori.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Finalità del trattamento</SectionTitle>
          <OrderedList>
            <li>Registrare ed attivare l’account dell’Utente, mediante il quale accedere ai servizi forniti per il tramite della Piattaforma.</li>
            <li>Dar corso alle attività preliminari e conseguenti all’acquisto dei servizi forniti mediante la Piattaforma, gestire l’erogazione del servizio stesso, nonché l’adempimento di ogni altro obbligo derivante dal contratto con l’Utente.</li>
            <li>Trasmettere, per conto dell’Utente, i dati personali forniti ai fornitori, al fine di permettere la conclusione del contratto di noleggio con gli stessi.</li>
            <li>Permettere all’Utente di gestire le proprie preferenze, revocare o prestare consensi ed esercitare i propri diritti in ordine al trattamento dei propri dati personali da parte della Piattaforma.</li>
            <li>Adempiere agli obblighi previsti dalla legge, da un regolamento, dalla normativa comunitaria o da un ordine dell’Autorità Amministrativa o Giudiziaria.</li>
            <li>Gestire l’eventuale contenzioso, giudiziale e/o stragiudiziale, tra EugeniUp, l’Utente, i fornitori e le eventuali terze parti coinvolte e/o interessate.</li>
            <li>Usare i dati a fini statistici e di profilazione, per lo sviluppo, la manutenzione ed il miglioramento dei prodotti e dei servizi.</li>
          </OrderedList>
        </Section>

        <Section>
          <SectionTitle>Base giuridica</SectionTitle>
          <Note>
            <Text>Non sono previsti processi decisionali automatizzati.</Text>
            <Text>
              Le condizioni di legittimità del trattamento sono basate, a seconda della finalità, sul consenso dell’interessato, sull’esecuzione di misure contrattuali o precontrattuali, sull’adempimento di obblighi di legge e sul legittimo interesse del Titolare.
            </Text>
          </Note>
        </Section>

        <Section>
          <SectionTitle>Tempo di conservazione</SectionTitle>
          <Text>
            I dati personali verranno conservati per il periodo in cui l’Utente lascerà attivo il proprio account e, se successivo, per il periodo di 10 anni dalla cessazione dell’ultimo rapporto contrattuale. Sono fatti salvi eventuali periodi ulteriori di conservazione previsti dalla legge.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Comunicazione dei dati e trasferimento verso Paesi Extra UE</SectionTitle>
          <Text>
            I dati personali potranno essere comunicati a soggetti esterni che, qualora trattino i dati per conto di EugeniUp, saranno nominati responsabili del trattamento, oltre che alla Pubblica Amministrazione ed all’Autorità giudiziaria, in adempimento di obblighi di legge o giurisdizionali, nonché a soggetti terzi in esecuzione dei servizi di intermediazione del Titolare.
          </Text>
          <Text>In particolare, i dati possono essere comunicati a:</Text>
          <List>
            <li>esperti tecnici che assistano il Titolare ai fini dello sviluppo, della manutenzione e della cura della Piattaforma;</li>
            <li>società fornitrici del servizio di hosting dei dati oggetto di trattamento;</li>
            <li>professionisti legali e contabili;</li>
            <li>altri soggetti che assistano il Titolare ai fini della fornitura dei servizi;</li>
            <li>fornitori dei servizi di noleggio.</li>
          </List>
          <Text>
            Non è previsto il trasferimento dei dati verso Paesi terzi, salvo che per finalità logistiche ed operative legate al servizio di hosting. In tal caso, i dati personali potranno essere oggetto di trasferimento verso Paesi non appartenenti all’UE per i quali sussista una decisione di adeguatezza della Commissione UE, ovvero forniscano adeguate garanzie ai sensi dell’art. 46 GDPR.
          </Text>
          <Text>Non è prevista la diffusione dei dati personali oggetto di trattamento.</Text>
        </Section>

        <Section>
          <SectionTitle>Misure di sicurezza</SectionTitle>
          <Text>
            I dati personali saranno sottoposti a trattamento cartaceo ed informatico. Saranno adottate tutte le procedure idonee a proteggerne la riservatezza, l’integrità e la disponibilità delle informazioni nel rispetto delle norme vigenti.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Diritti dell’interessato</SectionTitle>
          <Text>Ai sensi degli artt. 13-21 del GDPR, alle condizioni ivi previste, l’interessato potrà esercitare nei confronti di EugeniUp i seguenti diritti:</Text>
          <List>
            <li>revocare il consenso al trattamento dei dati;</li>
            <li>accesso ai dati trattati e ricevere una copia degli stessi;</li>
            <li>rettifica o aggiornamento dei propri dati personali;</li>
            <li>cancellazione dei dati personali nei casi previsti dal GDPR;</li>
            <li>portabilità dei dati in formato strutturato e leggibile da dispositivo automatico;</li>
            <li>limitazione del trattamento;</li>
            <li>opposizione al trattamento per motivi connessi alla propria situazione particolare;</li>
            <li>proporre reclamo all’Autorità Garante.</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>Esercizio dei diritti dell’interessato</SectionTitle>
          <Text>
            Per qualsiasi richiesta e per l’esercizio dei propri diritti, l’Utente può inviare una e-mail al Titolare al seguente indirizzo:
            {' '}
            <a href="mailto:eugeniupsrl@pec.it">eugeniupsrl@pec.it</a>.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Modifiche alla privacy policy</SectionTitle>
          <Text>
            EugeniUp S.r.l. si riserva il diritto di apportare modifiche alla presente privacy policy in qualunque momento dandone adeguata informativa agli Utenti, che potranno revocare il consenso prestato al trattamento dei relativi dati personali, fermo quanto sopra previsto.
          </Text>
          <Text><strong>Ultimo aggiornamento:</strong> 3.3.2025</Text>
        </Section>
      </Content>

      <Footer>
        Documento informativo della piattaforma AsoBike. Per tornare al sito principale, usa il dominio del servizio come di consueto.
      </Footer>
    </Container>
  </Page>
);

export default PrivacyPolicy;